export function useMineFilter() {
  const { loggedIn } = useUserSession();
  const { bool } = useUrlFilterValues();
  const mine = bool("mine");

  return computed<boolean>({
    get: () => loggedIn.value && mine.value,
    set: (value) => {
      mine.value = value;
    },
  });
}
